import { EventrDate } from '@eventr/common'
import { Stack } from '@mui/material'
import { useMemo } from 'react'
import { getMinutesFromUnixTimestamp } from '../../../utils'
import { useFormatValue } from '../../hooks/useFormatValue'
import { useScreenTypeContext } from '../../state/screenTypeProvider'
import { CardText } from '../subComponents/cardText'

interface IEventTimeRowProps {
    start?: string
    end?: string
}

export const EventTimeRow = ({ start, end }: IEventTimeRowProps) => {
    const { formatValue } = useFormatValue()
    const { screenType } = useScreenTypeContext()
    const sameTime = useMemo(() => {
        if (!end) return true

        return (
            getMinutesFromUnixTimestamp(new EventrDate(start).getUnixMs) ===
            getMinutesFromUnixTimestamp(new EventrDate(end).getUnixMs)
        )
    }, [start, end])

    if (sameTime) {
        if (screenType === 'upNext') return null
        return (
            <Stack direction={'row'}>
                <CardText>{formatValue(start ?? '', 'time')}</CardText>
            </Stack>
        )
    }

    return (
        <Stack justifyContent={'space-between'} direction={'row'}>
            <CardText>{formatValue(start ?? '', 'time')}</CardText>
            {!sameTime && (
                <>
                    <CardText textAlign={'center'}>
                        {formatValue(start ?? '', 'timeDifferenceV2', [end ?? ''])}
                    </CardText>
                    <CardText component={'p'} textAlign={'end'}>
                        {formatValue(end ?? '', 'time')}
                    </CardText>
                </>
            )}
        </Stack>
    )
}
